import { EventEmitter, Injectable, signal, Signal } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

/**
 * This service should be replacable by Angular 17+ native API, todo - when upgrading version change handlers and best remove this service.
 * https://v16.angular.io/guide/signals
 */
@Injectable({
  providedIn: 'root'
})
export class SignalsService {
  private summaryOwnedInvestments = new BehaviorSubject<boolean>(false);
  public summaryOwnedInvestments$ = this.summaryOwnedInvestments.asObservable();

  private confirmEtf = new EventEmitter<boolean>(false);
  public confirmEtf$ = this.confirmEtf.asObservable();

  private confirmNewPortfolioVat = new BehaviorSubject<boolean | null>(null);
  public confirmNewPortfolioVat$ = this.confirmNewPortfolioVat.asObservable();

  private modalClosed = new EventEmitter<boolean>();
  public modalClosed$ = this.modalClosed.asObservable();

  private rebalancingSwitchConfirmed = new EventEmitter<boolean>();
  public rebalancingSwitchConfirmed$ = this.rebalancingSwitchConfirmed.asObservable();

  private opfAdditionConfirmed = new Subject<boolean>();
  public opfAdditionConfirmed$ = this.opfAdditionConfirmed.asObservable();

  private feesChangeConfirmed = new Subject<boolean>();
  public feesChangeConfirmed$ = this.feesChangeConfirmed.asObservable();

  private investmentDeleted = new EventEmitter<never>();
  public investmentDeleted$ = this.investmentDeleted.asObservable();

  private investmentsSectionInView = new Subject<boolean>();
  public investmentsSectionInView$ = this.investmentsSectionInView.asObservable();

  private investmentsHeaderLinkClicked = new Subject<void>();
  public investmentsHeaderLinkClicked$ = this.investmentsHeaderLinkClicked.asObservable();

  private userUpdate = new Subject<void>();
  public storageChanged$ = this.userUpdate.asObservable();

  private _translationsLoadedSignal = signal<boolean>(false);

  public get translationsLoaded(): Signal<boolean> {
    return this._translationsLoadedSignal.asReadonly();
  }

  public setTranslationsLoaded(): void {
    this._translationsLoadedSignal.set(true);
  }

  public updateSummaryOwnedInvestments(): void {
    this.summaryOwnedInvestments.next(false);
    this.summaryOwnedInvestments.next(true);
  }

  public updateEtf(): void {
    this.confirmEtf.emit(true);
  }

  public modalClose(): void {
    this.modalClosed.emit();
  }

  public investmentDetailDeleted(): void {
    this.investmentDeleted.emit();
  }

  public confirmRebalancingSwitch(): void {
    this.rebalancingSwitchConfirmed.emit(true);
  }

  public opfAdditionConfirm(): void {
    this.opfAdditionConfirmed.next(true);
  }

  public confirmFeesChange(): void {
    this.feesChangeConfirmed.next(true);
  }

  /**
  * for same window native storageChanged listeners are not called,
  * this is workaround to prevent redirecting auth user to login page with visible header
  */
  public triggerUserUpdate(): void {
    this.userUpdate.next();
  }

  public confirmCreateNewPortfolioVat(flag: boolean): void {
    this.confirmNewPortfolioVat.next(flag);
  }

  public setInvestmentsSectionInView(inView: boolean): void {
    this.investmentsSectionInView.next(inView);
  }

  public investmentsTopNavLinkClicked(): void {
    // to trigger scroll to investments
    setTimeout(() => this.investmentsHeaderLinkClicked.next(), 0);
  }

}
